export type AddressSuggestionListKeyAction =
  | { type: "none" }
  | { type: "highlight"; index: number }
  | { type: "select"; index: number }
  | { type: "close" };

export function resolveAddressSuggestionListKey(params: {
  isOpen: boolean;
  key: string;
  highlightIndex: number;
  itemCount: number;
}): AddressSuggestionListKeyAction {
  if (!params.isOpen || params.itemCount <= 0) {
    return { type: "none" };
  }

  const lastIndex = params.itemCount - 1;
  const current = params.highlightIndex;

  if (params.key === "ArrowDown") {
    if (current < 0) {
      return { type: "highlight", index: 0 };
    }

    return { type: "highlight", index: Math.min(current + 1, lastIndex) };
  }

  if (params.key === "ArrowUp") {
    if (current < 0) {
      return { type: "highlight", index: 0 };
    }

    return { type: "highlight", index: Math.max(current - 1, 0) };
  }

  if (params.key === "Enter") {
    const index = current >= 0 ? current : 0;

    return { type: "select", index };
  }

  if (params.key === "Escape") {
    return { type: "close" };
  }

  return { type: "none" };
}
